<template>
	<ul
		class="grid grid-cols-[repeat(2,minmax(min-content,max-content))] gap-x-2"
	>
		<li
			v-for="[key, value] in displayedEntries"
			:key="key"
			class="grid grid-cols-subgrid col-span-full"
		>
			<span class="font-semibold text-[var(--text-primary)]">
				{{ key }}
			</span>
			<span>{{ value }}</span>
		</li>
	</ul>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
	entries: Record<string, string | undefined>;
}>();

const displayedEntries = computed(() => {
	// filters properties to only display those with a value
	return Object.entries(props.entries).filter(([, value]) => value);
});
</script>
